import { useState } from "react";
import { Button, Col, CardGroup } from "react-bootstrap";
import Table from "../../../../components/Table";
import ButtonLink from "../../../../components/ButtonLink";
import SearchFilter from "../../../../components/SearchFilter";
import AnimatedProgressBar from "../../../../components/AnimatedProgressBar";
import ContentModal from "../../../../components/ContentModal";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";

export default function WorkOrder() {
  const [duration, setDuration] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [data, setData] = useState([]);
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row?.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "หมายเลขแผน PM",
      selector: (row) => row?.Pm_No,
      minWidth: "200px"
    },
    {
      name: "PM/ครั้งที่",
      selector: (row) => row?.Pm_Item,
      minWidth: "150px"
    },
    {
      name: "เดือน/ครั้ง",
      selector: (row) => row?.Month_Item,
      minWidth: "150px"
    },
    {
      name: "เลขที่โครงการ",
      selector: (row) =>
        row?.PMPlan?.CustContractItem?.CustContract?.Project_No,
      minWidth: "200px"
    },
    {
      name: "เลขที่สัญญา",
      selector: (row) => row?.PMPlan?.CustContractItem?.Contract_No,
      minWidth: "150px"
    },
    {
      name: "ประเภทสัญญา",
      selector: (row) => row?.PMPlan?.CustContractItem?.Contract_Type,
      minWidth: "200px"
    },
    {
      name: "รหัสลูกค้า/สาขา",
      selector: (row) => row?.PMPlan?.Customer?.Cus_Code,
      minWidth: "200px"
    },
    {
      name: "วันที่เริ่มสัญญา",
      selector: (row) => row.Age_Start_Date,
      format: (row) => formatDate(row.Age_Start_Date),
      minWidth: "200px"
    },
    {
      name: "วันที่สิ้นสุดสัญญา",
      selector: (row) => row.Age_End_Date,
      format: (row) => formatDate(row.Age_End_Date),
      minWidth: "200px"
    }
  ];
  const searchInput = [
    {
      name: "PMPlan.Plan_No",
      label: "หมายเลขแผน PM",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Pm_Item",
      label: "PM/ครั้งที่",
      size: "1_5",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "PMPlan.CustContractItem.CustContract.Customer.Cus_Code",
      label: "รหัสลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "PMPlan.CustContractItem.CustContract.Customer.Cus_Name",
      label: "ชื่อลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "PMPlan.Customer.Cus_Code",
      label: "รหัสสาขา",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "PMPlan.Customer.Cus_NumBranch",
      label: "เลขที่สาขา",
      size: "1_5",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "PMPlan.Customer.Cus_Name",
      label: "ชื่อสาขา",
      size: 6,
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "createdBy",
      label: "ผู้สร้างแผน",
      size: "4_5",
      type: "text",
      disabled: true
    },
    {
      name: "Pm_No_Status",
      label: "สถานะงาน",
      type: "text",
      disabled: true
    },
    {
      name: "",
      label: "วันที่สร้างใบสั่งงาน",
      type: "date",
      disabled: true
    }
  ];
  const buttonLink = [
    {
      name: "ข้อมูลใบสั่งงาน",
      to: "create",
      color: "outline-secondary",
      state: { name: "work_order", type: "order" }
    },
    {
      name: "นำเข้าหมายเลขงานลูกค้า (Ticket No.)",
      to: "create",
      color: "outline-secondary",
      state: { name: "work_order", type: "ticket" }
    },
    {
      name: "ใบขอเบิก",
      to: "/reimbursement_refund",
      color: "outline-secondary"
    }
  ];

  return (
    <>
      <CardDisplayComponent
        header={{
          title: {
            className: "text-center ",
            text: "สร้างใบสั่งงาน Service Request"
          }
        }}
        body={{
          element: (
            <SearchFilter
              data={data.Array}
              inputField={searchInput}
              searchCallback={(search) => setSearchValue(search)}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{
          className: "d-flex justify-content-between align-items-end",
          title: { text: "รายละเอียดสำหรับสร้างใบสั่งงาน" },
          button: (
            <CardGroup>
              <Button
                variant="success"
                className="me-2 px-5 py-2 rounded-pill"
                onClick={() => {
                  let startTime,
                    time = true;
                  if (time) startTime = new Date();
                  setTimeout(() => {
                    time = false;
                    if (!time && startTime) setDuration(new Date() - startTime);
                  }, 2000);
                  setShowModal((prev) => ({ ...prev, CT: !showModal.CT }));
                }}
              >
                สร้างเลขที่ใบสั่งงาน
              </Button>

              <ContentModal
                show={showModal}
                className={{ footer: "justify-content-center border-top-0" }}
                header="กำลังสร้างหมายเลข PM"
                body={
                  <>
                    <AnimatedProgressBar
                      duration={duration}
                      onComplete={(progress) => {
                        if (progress) {
                          setShowModal(!showModal);
                          setDuration(0);
                        }
                      }}
                    />
                    <p className="mb-0 opacity-75">
                      กรุณารอสักครู่ ระบบกำลังประมวลผลข้อมูลให้ท่าน...
                    </p>
                  </>
                }
                footer={
                  <Button
                    variant="outline-secondary"
                    className="me-2 px-5 py-2 text-dark rounded-pill"
                    onClick={() => setShowModal(!showModal)}
                  >
                    ยกเลิก
                  </Button>
                }
              />

              {buttonLink.map(({ name, to, color, state }) => (
                <Col key={name} sm={1} className="px-2 w-auto">
                  <ButtonLink
                    linkTo={to}
                    stateData={state}
                    buttonClass="px-5 py-2 text-dark rounded-pill"
                    buttonName={name}
                    buttonColor={color}
                  />
                </Col>
              ))}
            </CardGroup>
          )
        }}
        body={{
          element: (
            <Table
              data={data}
              column={columns}
              searchFilter={searchValue}
              pending={loading}
              pagination
            />
          )
        }}
      />
    </>
  );
}
